/**
 * hidden 菜单隐藏或者显示
 * disabled 菜单是否可点击
 * parentPath 父级菜单路径
 * code中带有disabled的表明已经授权，但是本次不做展示
 * 菜单权限控制，c2MenuList：智慧商场的菜单；c4MenuList：智慧社区的菜单
 */
const { VITE_APP_CHANNEL } = import.meta.env;
export const c2MenuList = [
  {
    path: '/ibms',
    title: '运行',
    authCodes: ['IBMS'],
    icon: 'ibms',
    children: [
      {
        path: '/monitor/index',
        title: '设备监控',
        authCodes: ['DEVICE_MONITOR'],
        icon: 'LevelList',
        meta: {
          projectCheckStrictly: true,
          isThreeModel: true,
        },
      },
      {
        path: '/monitor/router',
        title: '设备路由',
        authCodes: ['DEVICE_ROUTER'],
        icon: 'LevelList',
        meta: {
          isThreeModel: true,
          projectCheckStrictly: true,
        },
      },
      {
        path: '/environment/index',
        title: '环境实时监测',
        authCodes: ['REAL_TIME_ENVIRONMENTAL_MONITOR'],
        icon: 'LevelList',
        meta: {},
      },
      {
        path: '/ibms/history/record/index',
        title: '历史数据',
        authCodes: ['HISTORY_RECORD'],
        icon: 'List4',
        children: [],
      },
      {
        path: '/ibms/model-config/index',
        title: '策略管理',
        authCodes: ['STRATEGIC_MANAGE'],
        icon: 'Pm',
        children: [
          {
            path: '/ibms/linkage-rule',
            title: '联动控制',
            authCodes: ['LINKAGE_CONTROL'],
            icon: 'Danger2',
            children: [],
          },
          {
            path: '/ibms/model-config/index',
            title: '模式配置',
            authCodes: ['MODEL_MANAGE'],
            icon: 'Danger2',
            children: [],
          }
        ],
      },
      {
        path: '/ibms/rule',
        title: '告警规则',
        authCodes: ['IBMS_ALARM_CONFIG'],
        icon: 'Warning2',
        children: [
          {
            path: '/ibms/normal-alarm-config-group',
            title: '普通告警规则',
            authCodes: ['NORMAL_ALARM'],
            icon: 'Danger2',
            children: [],
          },
          {
            path: '/ibms/logical-alarm-config',
            title: '逻辑告警规则',
            authCodes: ['LOGICAL_ALARM_RULES'],
            icon: 'Danger2',
            children: [],
          },
          {
            path: '/ibms/device-alarm-rule-config',
            title: '设备告警规则',
            authCodes: ['DEVICE_ALARM_RULE'],
            icon: 'Danger2',
            children: [],
          }
        ],
      },
      {
        path: '/ibms/message-center',
        title: '消息中心',
        authCodes: ['MESSAGE_CENTER'],
        icon: 'List4',
        children: [
          {
            path: '/ibms/message-center/index',
            title: '设备离线历史',
            authCodes: ['DEVICE_OFFLINE_HISTORY'],
            icon: 'Danger2',
            children: [],
          },
          {
            path: '/dmp/message-center/sensor-monitor',
            title: '传感器监测',
            authCodes: ['SENSOR_MONITOR'],
            icon: 'Danger2',
            children: [],
          }
        ],
      },
      {
        path: '/ibms/risk-management',
        title: '风险管理',
        authCodes: ['RISK_MANAGEMENT'],
        icon: 'List4',
        children: [
          {
            path: '/ibms/risk-management/diagnosis-diagram',
            title: '风险诊断图谱',
            authCodes: ['RISK_DIAGNOSIS_DIAGRAM'],
            icon: 'Danger2',
            children: [],
          }
        ],
      }
    ],
  },
  {
    path: '/quality',
    title: '品质',
    authCodes: ['SAFETY'],
    icon: 'safety',
    children: [
      {
        path: '/safety/fire',
        title: '消防管理',
        authCodes: ['FIRE_MONITORING', 'FIRE_ALARM_RULES', 'FIRE_ANALYSIS'],
        icon: 'SuitcaseSearch',
        children: [
          {
            path: '/quality/fireProrection',
            title: '消防监测',
            authCodes: ['FIRE_MONITORING'],
            icon: 'SuitcaseSearch',
            children: [],
          },
          {
            path: '/ibms/fire-device-monitor/config',
            title: '消防监控配置',
            authCodes: ['FIRE_DEVICE_MONITOR_CONFIG'],
            icon: 'LevelList',
            meta: {
              projectCheckStrictly: true,
              isThreeModel: true,
            },
          },
          {
            path: '/ibms/fire-maintenance/fire-group',
            title: '消防维保检测',
            authCodes: ['FIRE_MAINTENANCE_MONITORING'],
            icon: 'Danger2',
            children: [],
          },
          {
            path: '/ibms/safety-normal-alarm-config-group',
            title: '告警规则',
            authCodes: ['FIRE_ALARM_RULES'],
            icon: 'SuitcaseSearch',
            children: [],
          },
          {
            path: '/ibms/history/record/safety',
            title: '消防分析',
            authCodes: ['FIRE_ANALYSIS'],
            icon: 'SuitcaseSearch',
            children: [],
          },
          {
            path: '/ibms/fire-abnormal-target',
            title: '异常分析',
            authCodes: ['FIRE_ABNORMAL_TARGET'],
            icon: 'SuitcaseSearch',
            children: [],
          }
        ],
      },
      {
        path: '/quality/map/index',
        title: '安全风险地图',
        authCodes: ['SECURITY_RISK_MAP'],
        icon: 'SuitcaseSearch',
        children: [],
      },
      {
        path: '/quality/event/center',
        title: '巡检事件中心',
        authCodes: ['INSPECTION_EVENT_CENTER'],
        icon: 'SuitcaseSearch',
        children: [],
        meta: {
          isThreeModel: true,
        },
      },
      {
        path: '/quality/duty',
        title: '巡检执行',
        authCodes: ['INSPECTION_TASK'],
        icon: 'Loop',
        children: [
          {
            path: '/quality/duty/random',
            title: '随机巡检',
            authCodes: ['INSPECTION_TASK_RANDOM'],
            icon: 'SuitcaseSearch',
            children: [],
            meta: {
              isThreeModel: true,
            },
          },
          {
            path: '/quality/duty/random',
            title: '计划巡检',
            authCodes: ['INSPECTION_TASK_PLAN'],
            icon: 'SuitcaseSearch',
            children: [],
          },
          {
            path: '/insight/clound/execute',
            title: '云督勤',
            authCodes: ['INSPECTION_TASK_CLOUD'],
            icon: 'SuitcaseSearch',
            children: [],
          },
          {
            path: '/quality/duty/picture',
            title: '云巡检考评',
            authCodes: ['INSPECTION_TASK_PICTURE'],
            icon: 'SuitcaseSearch',
            children: [],
          }
        ],
      },
      {
        path: '/insight/ai/inspection',
        title: '巡检任务管理',
        authCodes: ['INSPECTION_TASK_CONFIG'],
        icon: 'Loop',
        children: [
          {
            path: '/insight/ai/inspection',
            title: 'AI巡检任务',
            authCodes: ['AI_INSPECTION_TASK'],
            icon: 'SuitcaseSearch',
            children: [],
          },
          /*
           * {
           *   path: '/quality/ai/config',
           *   title: '计划巡检任务',
           *   authCodes: ['INSPECTION_TASK_CONFIG'],
           *   icon: 'SuitcaseSearch',
           *   children: [],
           * },
           */
          {
            path: '/insight/clound/duty-config',
            title: '云督勤任务',
            authCodes: ['CLOUD_DUTY'],
            icon: 'SuitcaseSearch',
            children: [],
          }
        ],
      },
      {
        path: '/insight/ai-screen',
        title: '巡检场景管理',
        authCodes: ['SAFETY_SCREEN'],
        icon: 'Loop',
        children: [
          {
            path: '/insight/ai-screen/index',
            title: 'AI场景模板',
            authCodes: ['SAFETY_SCREEN_TEMPLATE'],
            icon: 'SuitcaseSearch',
            children: [],
          },
          {
            path: '/insight/ai-screen/screenHouse',
            title: 'AI算法仓库',
            authCodes: ['SAFETY_SCREEN_HOUSE'],
            icon: 'SuitcaseSearch',
            children: [],
          },
          {
            path: '/insight/clound/type-config',
            title: '云督勤场景',
            authCodes: ['CLOUD_TEMPLATE'],
            icon: 'SuitcaseSearch',
            children: [],
          },
          {
            path: '/insight/clound/point-config',
            title: '云督勤配置',
            authCodes: ['CLOUD_CONFIG'],
            icon: 'SuitcaseSearch',
            children: [],
          }
        ],
      },
      {
        path: '/insight/carous',
        title: '视频轮播',
        authCodes: ['VIDEO_CAROUS'],
        icon: 'Loop',
        children: [
          {
            path: '/insight/carous/index',
            title: '轮播大屏',
            authCodes: ['VIDEO_CAROUS_SCREEN'],
            icon: 'SuitcaseSearch',
            children: [],
            meta: {
              isOpenPage: true,
            },
          },
          {
            path: '/insight/carous/config',
            title: '轮播配置',
            authCodes: ['VIDEO_CAROUS_CONFIG'],
            icon: 'SuitcaseSearch',
            children: [],
          }
        ],
      },
      {
        path: '/report',
        title: '报表分析',
        authCodes: ['SAFE_STATEMENT_ANALYSIS'],
        icon: 'SuitcaseSearch',
        children: [
          {
            path: '/quality/report/ai-count',
            title: 'AI统计',
            authCodes: ['REPORT_AI_COUNT'],
            icon: 'SuitcaseSearch',
            children: [],
            meta: {
              isThreeModel: true,
            },
          },
          {
            path: '/insight/report/ai-rule',
            title: 'AI巡检分析',
            authCodes: ['REPORT_AI_RULE'],
            icon: 'SuitcaseSearch',
            children: [],
          },
          {
            path: '/insight/report/random-rule',
            title: '随机巡检分析',
            authCodes: ['REPORT_RANDPM'],
            icon: 'SuitcaseSearch',
            children: [],
          },
          {
            path: '/insight/report/workorder-rule',
            title: '工单看板',
            authCodes: ['REPORT_WORKORDER_REPORT'],
            icon: 'SuitcaseSearch',
            children: [],
          },
          {
            path: '/insight/report/video-device',
            title: '视频设备看板',
            authCodes: ['REPORT_VIDEO_DEVICE'],
            icon: 'SuitcaseSearch',
            children: [],
          }
        ],
      }
    ],
  },
  {
    path: '/ems',
    title: '能源',
    authCodes: ['EMS'],
    icon: 'energy',
    children: [
      {
        path: '/ems/home/index',
        title: '数据看板',
        icon: 'ChartsBoard',
        authCodes: ['COCKPIT'],
        meta: {
          isThreeModel: false,
        },
      },
      {
        path: '/ems/energy-analysis',
        title: '能源分析',
        icon: 'DataAnalysis',
        authCodes: ['ENERGY_ANALYSE'],
        children: [
          {
            path: '/ems/energy-analysis/project',
            title: '单项目能耗分析',
            authCodes: ['ENERGY_ANALYSE_S'],
          },
          {
            path: '/ems/energy-analysis/multiple-projects',
            title: '多项目能耗分析',
            authCodes: ['ENERGY_ANALYSE_M'],
          },
          {
            path: '/ems/energy-analysis/branch-unbalanced',
            title: '数据质量看板',
            authCodes: ['ENERGY_ANALYSE_DASH'],
          },
          {
            path: '/ems/energy-analysis/meta-branch-topology',
            title: '表具支路拓扑',
            authCodes: ['META_BRANCH_TOPOLOGY'],
          },
          {
            path: '/ems/energy-analysis/energy-branch-topology',
            title: '能耗分项拓扑',
            authCodes: ['ENERGY_TOPOLOGY'],
          },
          {
            path: '/ems/energy-analysis/energy-report-manage',
            title: '能耗报告管理',
            authCodes: ['ENERGY_REPORT_MANAGE'],
          }
        ],
      },
      {
        path: '/ems/energy',
        title: '能源报表',
        icon: 'ChartsBoard',
        authCodes: ['ACHIEVE_DATA'],
        children: [
          {
            path: '/ems/energy/energy-take-report/index',
            title: '能耗发生报表',
            authCodes: ['ENERGY_REPORT'],
          },
          {
            path: '/ems/energy/energy-detail/index',
            title: '能耗明细报表',
            authCodes: ['ENERGY_DETAIL'],
          },
          {
            path: '/ems/energy/meter-detail-hourly/index',
            title: '多时间维度能耗',
            authCodes: ['ENERGY_HOURLY'],
          },
          {
            path: '/ems/energy/meter-detail/index',
            title: '统计表底数查询',
            authCodes: ['METER_DETAIL'],
          },
          {
            path: '/ems/energy/meter-detail-original/index',
            title: '原始表底数查询',
            authCodes: ['METER_DETAIL_ORIGINAL'],
          },
          {
            path: '/ems/energy/ocr-report/index',
            title: 'OCR报表',
            authCodes: ['ENERGY_OCR'],
          }
        ],
      },
      {
        path: '/ems/energy-target',
        title: '目标管理',
        icon: 'ForkedTree',
        authCodes: ['ENERGY_TARGET'],
        children: [
          {
            path: '/ems/energy-conservation-board/index',
            title: '节能看板',
            authCodes: ['ENERGY_CONSERVATION_BOARD'],
          },
          {
            path: '/ems/energy-target/energy/index',
            title: '能耗目标管理',
            authCodes: ['SUBMENU_ENERGY_TARGET'],
          },
          {
            path: '/ems/energy-target/energy/cost-budget/index',
            title: '能源预算管理',
            authCodes: ['ENERGY_FEE_BUDGET'],
          },
          {
            path: '/ems/energy-target/city-standard',
            title: '基准单方能耗',
            authCodes: ['CITY_ENERGY_STANDARD'],
          }
        ],
      },
      {
        path: '/ems/strategy-and-model',
        title: '策略及模型',
        icon: 'Materials1',
        authCodes: ['STRATEGY_AND_MODEL'],
        children: [
          {
            path: '/ems/time-model/index',
            title: '时间策略',
            authCodes: ['TIME_MODEL'],
          },
          {
            path: '/ems/energy-model/index',
            title: '能耗模型',
            authCodes: ['MODEL'],
          },
          {
            path: '/ems/alarm/alarm-rule-config/index',
            title: '报警规则',
            authCodes: ['ALARM_RULE_CONFIG'],
          },
          {
            path: '/ems/alarm/energy-alarm-rule-config/index',
            title: '能耗报警配置',
            authCodes: ['ENERGY_ALARM_RULE_CONFIG'],
          }
        ],
      },

      {
        path: '/ems/cost',
        title: '租户费用',
        icon: 'Price1',
        authCodes: ['COST'],
        children: [
          {
            path: '/ems/cost/config/tenant-manage',
            title: '租户管理',
            authCodes: ['TENANT_MANAGE'],
          },
          {
            path: '/ems/cost/config/tenant-cost',
            title: '租户能源费用',
            authCodes: ['TENANT_COST'],
          },
          {
            path: '/ems/cost/config/cost-scheme-config',
            title: '费用方案配置',
            authCodes: ['COST_SCHEME_CONFIG'],
          }
        ],
      },

      {
        path: '/ems/energy-input',
        title: '填报管理',
        icon: 'List6',
        authCodes: ['MANUAL_FILLING'],
        children: [
          {
            path: '/ems/energy-input/manual-stopwatch/index',
            title: '人工抄表',
            authCodes: ['MANUAL_METERM'],
          },
          {
            path: '/ems/energy-input/merchant-data-patching/index',
            title: '表底数修正',
            authCodes: ['MERCHANT_DATA_PATCHING'],
          },
          {
            path: '/ems/energy-input/meter-reading-config/index',
            title: '抄表计划配置',
            authCodes: ['METER_READING_CONFIG'],
          },
          /*
           * {
           *   path: '/ems/energy-input/meter-reading-config/edit',
           *   title: '抄表计划配置-详情',
           *   authCodes: ['METER_READING_CONFIG'],
           * }
           */
          {
            path: '/ems/energy-input/monthly-energy-report/index',
            title: '月度能耗填报',
            authCodes: ['MONTHLY_ENERGY'],
          },
          {
            path: '/ems/energy-input/ocr-meter/index',
            title: 'OCR抄表数据',
            authCodes: ['OCR_METER_DATA'],
          }
        ],
      },

      {
        path: '/ems/electric-substation/transformer/index',
        title: '变配电管理',
        icon: 'ChartsBoard',
        authCodes: ['ELECTRIC_SUBSTATION'],
      },

      {
        path: '/ems/two-carbon',
        title: '双碳管理',
        icon: 'Price1',
        authCodes: ['TWO_CARBON_MANAGEMENT'],
        children: [
          {
            path: '/ems/target/index',
            title: '双碳目标管理',
            authCodes: ['TWO_CARBON_TARGET'],
          },
          {
            path: '/ems/two-carbon/index',
            title: '数据质量看板',
            authCodes: ['TWO_CARBON_DATA_QUALITY_BOARD'],
          },
          {
            path: '/ems/two-carbon/performance',
            title: '碳履约管理',
            authCodes: ['TWO_CARBON_PERFORMANCE'],
          },
          {
            path: '/ems/two-carbon/tec-saving',
            title: '节能技术管理',
            authCodes: ['TWO_CARBON_TEC_SAVING'],
          },
          {
            path: '/ems/two-carbon/green-electricity',
            title: '绿电管理',
            authCodes: ['TWO_CARBON_GREEN_ELECTRICITY'],
          },
          {
            path: '/ems/two-carbon/solid-waste',
            title: '固废弃物',
            authCodes: ['TWO_CARBON_SOLID_WASTE'],
          },
          {
            path: '/ems/two-carbon/solid-waste-resource',
            title: '固废弃物及资源',
            authCodes: ['TWO_CARBON_SOLID_WASTE'],
          },
          {
            path: '/ems/two-carbon/monthly-energy-entry',
            title: '月度能耗录入',
            authCodes: ['TWO_CARBON_MONTHLY_ENERGY_ENTRY'],
          },
          {
            path: '/ems/two-carbon/month',
            title: '月度能耗报表',
            authCodes: ['TWO_CARBON_MONTH_REPORT'],
          },
          {
            path: '/ems/two-carbon/project',
            title: '项目接入',
            authCodes: ['TWO_CARBON_PROJECT'],
          }
        ],
      }
    ],
  },
  {
    path: '/oss',
    title: '运维',
    authCodes: ['OPERATION'],
    icon: 'oss',
    children: [
      {
        path: '/oss/realtime',
        title: '全局告警',
        authCodes: ['ALARM'],
        icon: 'Danger2',
        children: [
          {
            path: '/oss/realtime',
            title: '实时告警',
            authCodes: ['REAL_TIME_ALARM'],
            icon: 'Danger2',
            children: [],
            meta: {
              isThreeModel: true,
            },
          },
          {
            path: '/oss/history',
            title: '历史告警',
            authCodes: ['HISTORY_ALARM'],
            icon: 'Danger2',
            children: [],
          },
          {
            path: '/oss/quarantime',
            title: '隔离告警',
            authCodes: ['QUARANTINE_ALARM'],
            icon: 'Danger2',
            children: [],
          }
        ],
      }
    ],
  },
  {
    path: '/astm',
    title: '资产',
    authCodes: ['ASTM'],
    icon: 'ibms',
    children: [],
  },
  {
    path: '/space',
    title: '空间',
    authCodes: ['SPACE'],
    icon: 'space',
    children: [
      {
        path: '/space/space-tree/index',
        title: '空间树管理',
        authCodes: ['SPACE_TREE'],
        icon: 'OrgStru',
        children: [],
      },
      {
        path: '/space/online',
        title: '空间在线',
        authCodes: ['TARGET_SPACE_ONLINE'],
        icon: 'Danger2',
        blank: true,
        targetUrl: import.meta.env.VITE_APP_SPACE_ONLINE_URL || '',
      }
    ],
  },

  {
    path: '/system',
    title: '配置',
    authCodes: ['SYSTEM'],
    icon: 'system',
    children: [
      {
        path: '/system/overall-device-manage',
        title: '设备管理',
        authCodes: ['OVERALL_DEVICE_MANAGE'],
        icon: 'Process1',
        children: [
          {
            path: '/ibms/gateway-device',
            name: 'overall-device-manage-ibms',
            title: '运行设备',
            authCodes: ['OVERALL_DEVICE_MANAGE_IBMS'],
          },
          {
            path: '/ems/device',
            name: 'overall-device-manage-ems',
            authCodes: ['OVERALL_DEVICE_MANAGE_EMS'],
            title: '能源设备',
          },
          {
            path: '/insight/gateway-device',
            name: 'overall-device-manage-video',
            title: '视频设备',
            authCodes: ['OVERALL_DEVICE_MANAGE_VIDEO'],
          },
          {
            path: '/system/overall-device-manage/dictionary',
            name: 'overall-device-manage-dictionary',
            title: '设备字典',
            authCodes: ['OVERALL_DEVICE_MANAGE_DICTIONARY'],
          }
        ],
      },
      {
        path: '/system',
        title: '物联管理',
        authCodes: ['DMP_MANAGE'],
        icon: 'Process1',
        children: [
          {
            path: '/dmp/product/index',
            name: 'dmp-product-index',
            title: '设备类型',
            authCodes: ['DEVICE_TYPE_MANAGE'],
            icon: 'Process1',
          },
          {
            path: '/dmp/device/index',
            name: 'dmp-device-index',
            title: '设备',
            authCodes: ['DEVICE_MANAGE'],
            icon: 'Process1',
          },
          {
            path: '/dmp/physical-model/category-config',
            name: 'dmp-physical-model-category-config',
            title: '物模型管理',
            authCodes: ['PHYSICAL_MODEL_MANAGE'],
            icon: 'Process1',
          },
          {
            path: '/dmp/log-serve',
            name: 'dmp-log-serve',
            title: '设备日志',
            authCodes: ['LOG_MANAGE'],
            icon: 'Process1',
          },
          {
            path: '/dmp/rule/index',
            name: 'dmp-rule-index',
            title: '规则引擎',
            authCodes: ['RULE_ENGINE'],
            icon: 'Process1',
          },
          {
            path: '/dmp/rtu-manage/index',
            name: 'dmp-gateway-manage-index',
            title: '网关管理',
            authCodes: ['GATEWAY_MANAGE'],
            icon: 'Process1',
          }
        ],
      },
      {
        path: '/system/ibms/config',
        title: '运行配置',
        authCodes: ['IBMS_CONFIG'],
        icon: 'ModeList',
        children: [
          {
            path: '/system/device/bianyuan',
            title: '边缘管理',
            authCodes: ['EDGE_MANAGEMENT'],
            icon: 'Toolts',
            children: [],
          },
          {
            path: '/system/device/tool',
            title: '调试工具',
            authCodes: ['IBMS_DEBUG_TOOL'],
            icon: 'Toolts',
            children: [],
          },
          {
            path: '/ibms/relative-time/index',
            title: '相对时间配置',
            authCodes: ['IBMS_RELATIVE_TIME'],
            icon: 'Toolts',
            children: [],
          },
          {
            path: '/ibms/relative-time/inner',
            title: '边缘端时间表',
            authCodes: ['IBMS_INNER_RELATIVE_TIME'],
            icon: 'Toolts',
            children: [],
          },
          {
            path: '/ibms/issue-history',
            title: '模式下发日志',
            authCodes: ['ISSUE_HISTORY_RECORD'],
            icon: 'Toolts',
            children: [],
          },
          {
            path: '/system/device/log',
            title: '操作日志',
            authCodes: ['IBMS_OPERATION_LOG'],
            icon: 'Toolts',
            children: [],
          },
          {
            path: '/ibms/device-monitor/config',
            title: '设备监控配置',
            authCodes: ['DEVICE_MONITOR_CONFIG'],
            icon: 'LevelList',
            meta: {
              projectCheckStrictly: true,
            },
          },
          {
            path: '/ibms/environment-config/index',
            title: '环境监测配置',
            authCodes: ['ENVIRONMENTAL_MONITOR_RULE'],
            icon: 'LevelList',
          },
          /*
           * {
           *   path: '/system/device/area',
           *   title: '重庆智慧小区',
           *   authCodes: [
           *     'SYSTEM'
           *   ],
           *   icon: 'ModeList',
           *   children: [],
           * },
           */
          {
            path: '/system/device/light',
            title: '智慧照明',
            authCodes: ['SMART_LIGHTING'],
            icon: 'ModeList',
            children: [],
          }
        ],
      },
      {
        path: '/insight/config',
        title: '安全配置',
        authCodes: ['SAFE_CONFIG'],
        icon: 'Process1',
        children: [
          {
            path: '/insight/config/work-order-type',
            title: '工单类型管理',
            authCodes: ['WORK_ORDER_TYPE_MANAGE'],
            icon: 'Toolts',
            children: [],
          }
          /*
           * {
           *   path: '/insight/config/space-property',
           *   title: '空间属性管理',
           *   authCodes: ['SPACE_ATTRIBUTE_MANAGE'],
           *   icon: 'Toolts',
           *   children: [],
           * }
           */
        ],
      },
      {
        path: '/system/energy',
        title: '能耗配置',
        authCodes: ['CONSUMPTION_CONFIG'],
        icon: 'Process1',
        children: [],
      },
      {
        path: '/system/general',
        title: '通行配置',
        authCodes: ['TRANSIT_CONFIG'],
        icon: 'Process1',
        children: [],
      },
      {
        path: '/ems/operator',
        title: '能源运维工具',
        authCodes: ['OPERATOR_TOOLS'],
        icon: 'Setting',
        children: [
          {
            path: '/ems/operator/template/index',
            name: 'system-operator-template-index',
            title: '运维',
            authCodes: ['TEMPLATE_MGT'],
            icon: 'Process1',
          },
          {
            path: '/ems/operator/energy-ck/index',
            name: 'system-operator-energy-ck-index',
            title: '能耗采样表',
            authCodes: ['ENERGY_CY'],
            icon: 'Process1',
          },
          {
            path: '/ems/operator/energy-computed/index',
            name: 'system-operator-energy-computed-index',
            title: '能耗计算表',
            authCodes: ['ENERGY_JS'],
            icon: 'Process1',
          },
          {
            path: '/ems/operator/energy-cck/index',
            name: 'system-operator-energy-cck-index',
            title: '能耗重采样表',
            authCodes: ['ENERGY_CCY'],
            icon: 'Process1',
          },
          {
            path: '/ems/operator/energy-recomputed/index',
            name: 'system-operator-energy-recomputed-index',
            title: '能耗重计算表',
            authCodes: ['ENERGY_CJS'],
            icon: 'Process1',
          },
          {
            path: '/ems/operator/his-data-migration/index',
            name: 'system-operator-his-data-migration-index',
            title: '历史数据迁移',
            authCodes: ['HIS_DATA_MIGRATION'],
            icon: 'Process1',
          },
          {
            path: '/ems/operator/device-migration-tool/index',
            name: 'system-operator-device-migration-tool-index',
            title: '设备迁移工具',
            authCodes: ['DEVICE_MIGRATION_TOOL'],
            icon: 'Process1',
          },
          {
            path: '/ems/operator/data-patching/index',
            name: 'system-operator-data-patching-index',
            title: '人工修补数据',
            authCodes: ['DATA_PATCHING'],
            icon: 'Process1',
          },
          {
            path: '/ems/operator/anomaly-data-monitoring/index',
            name: 'system-operator-anomaly-data-monitoring-index',
            title: '异常数据监控',
            authCodes: ['ANOMALY_DATA_MONITORING'],
            icon: 'Process1',
          },
          {
            path: '/ems/operator/dict-manage/index',
            name: 'system-operator-dict-manage-index',
            title: '字典管理',
            authCodes: ['DICT_MANAGE'],
            icon: 'Process1',
          },
          {
            path: '/ems/system/operator/energy-breakdown/index',
            name: 'system-operator-energy-breakdown-index',
            title: '离线能耗拆分',
            authCodes: ['ENERGY_BREAKDOWN'],
            icon: 'Process1',
          },
          {
            path: '/ems/system/operator/out-request-log/index',
            name: 'system-operator-out-request-log-index',
            title: '资管请求日志',
            authCodes: ['OUT_REQUEST_LOG'],
            icon: 'Process1',
          }
        ],
      },
      {
        path: '/system/project/index',
        title: '项目信息管理',
        authCodes: ['PROJECT_INFO'],
        icon: 'Process1',
        children: [],
      },
      {
        path: '/system/operate-log',
        title: '用户日志',
        authCodes: ['OPERATION_LOG_MANAGE'],
        icon: 'Process1',
        children: [],
      }
    ],
  },
  {
    path: '/user',
    title: '账号',
    authCodes: ['ACCOUNT'],
    icon: 'home',
    children: [
      {
        path: '/roleManage/index',
        title: '角色管理',
        authCodes: [
          'ROLE_MANAGE'
        ],
        icon: 'Process1',
        children: [],
      },
      {
        path: '/organizationalManage/index',
        title: '组架管理',
        authCodes: [
          'ORGANIZATIONAL_MANAGE'
        ],
        icon: 'Process1',
        children: [],
      }
    ],
  }
];

export const c4MenuList = [
  {
    path: '/home/index',
    title: '中枢',
    authCodes: ['SMART_CENTER'],
    icon: 'home',
  },
  {
    path: '/ibms',
    title: '运行',
    authCodes: ['IBMS'],
    icon: 'ibms',
    children: [
      {
        path: '/ibms/dashboard/index',
        title: '运行中枢',
        authCodes: ['IBMS_CENTER_DASHBOARD'],
        icon: 'LevelList',
        meta: {
          projectCheckStrictly: true,
        },
      },
      {
        path: '/ibm/index',
        title: '运维看板',
        authCodes: ['INDICATOR_OPERATION_DASHBOARD'],
        icon: 'ChartsBoard',
      },
      {
        path: '/ibm/overview',
        title: '设备运行概览',
        authCodes: ['EQUIPMENT_OPERATION_OVERVIEW'],
        icon: 'ChartsBoard',
      },
      {
        path: '/monitor/index',
        title: '设备监控',
        authCodes: ['DEVICE_MONITOR'],
        icon: 'LevelList',
        meta: {
          isThreeModel: true,
          projectCheckStrictly: true,
        },
      },
      {
        path: '/monitor/router',
        title: '设备路由',
        authCodes: ['DEVICE_ROUTER'],
        icon: 'LevelList',
        meta: {
          isThreeModel: true,
          projectCheckStrictly: true,
        },
      },
      {
        path: '/monitor/router',
        title: '设备路由',
        authCodes: ['DEVICE_ROUTER'],
        icon: 'LevelList',
        meta: {
          isThreeModel: true,
          projectCheckStrictly: true,
        },
      },
      {
        path: '/ibms/device-monitor/config',
        title: '设备监控配置',
        authCodes: ['DEVICE_MONITOR_CONFIG'],
        icon: 'LevelList',
        meta: {
          projectCheckStrictly: true,
        },
      },
      {
        path: '/environment',
        title: '环境监测',
        authCodes: [
          'ENVIRONMENT_DETECTION',
          'REAL_TIME_ENVIRONMENTAL_MONITOR',
          'ENVIRONMENTAL_MONITOR_RULE'
        ],
        icon: 'Materials1',
        children: [
          {
            path: '/environment/index',
            title: '环境实时监测',
            authCodes: ['REAL_TIME_ENVIRONMENTAL_MONITOR'],
            icon: 'LevelList',
            meta: {},
          },
          {
            path: '/ibms/environment-config/index',
            title: '环境监测配置',
            authCodes: ['ENVIRONMENTAL_MONITOR_RULE'],
            icon: 'LevelList',
            children: [
              {
                path: '/ibms/environment-config/type-config/index',
                title: '类型配置',
                authCodes: ['ENV_TYPE_CONFIG'],
                icon: 'Danger2',
                children: [],
              },
              {
                path: '/ibms/environment-config/group-config/index',
                title: '分组配置',
                authCodes: ['ENV_GROUP_CONFIG'],
                icon: 'Danger2',
                children: [],
              },
              {
                path: '/ibms/environment-config/rules-config/index',
                title: '规则配置',
                authCodes: ['ENV_RULES_CONFIG'],
                icon: 'Danger2',
                children: [],
              }
            ],
          }
        ],
      },
      {
        path: '/ibms/history/record/index',
        title: '历史数据',
        authCodes: ['HISTORY_RECORD'],
        icon: 'List4',
        children: [],
      },
      {
        path: '/ibms/model-config',
        title: '策略管理',
        authCodes: ['STRATEGIC_MANAGE'],
        icon: 'Pm',
        children: [
          {
            path: '/ibms/linkage-control',
            title: '联动控制',
            authCodes: ['LINKAGE_CONTROL'],
            icon: 'Danger2',
            children: [
              {
                path: '/ibms/linkage-rule',
                title: '联动规则',
                authCodes: ['LINKAGE_CONTROL'],
                icon: 'Danger2',
                children: [],
              },
              {
                path: '/ibms/linkage-group',
                title: '联动分组',
                authCodes: ['LINKAGE_CONTROL'],
                icon: 'Danger2',
                children: [],
              }
            ],
          },
          {
            path: '/ibms/model-config/index',
            title: '模式配置',
            authCodes: ['MODEL_MANAGE'],
            icon: 'Danger2',
            children: [],
          }
        ],
      },
      {
        path: '/ibms/rule',
        title: '告警规则',
        authCodes: ['IBMS_ALARM_CONFIG'],
        icon: 'Warning2',
        children: [
          {
            path: '/ibms/normal-alarm-config',
            title: '普通告警规则',
            authCodes: ['NORMAL_ALARM'],
            icon: 'Danger2',
            children: [
              {
                path: '/ibms/normal-alarm-config-group',
                title: '集团标准',
                authCodes: ['NORMAL_ALARM'],
                icon: 'Danger2',
                children: [],
              },
              {
                path: '/ibms/normal-alarm-config-project',
                title: '项目标准',
                authCodes: ['NORMAL_ALARM'],
                icon: 'Danger2',
                children: [],
              }
            ],
          },
          {
            path: '/ibms/logical-alarm/config',
            title: '逻辑告警规则',
            authCodes: ['LOGICAL_ALARM_RULES'],
            icon: 'Danger2',
            children: [
              {
                path: '/ibms/logical-alarm-config',
                title: '智能告警',
                authCodes: ['LOGICAL_ALARM_RULES'],
                icon: 'Danger2',
                children: [],
              },
              {
                path: '/ibms/logical-alarm-group',
                title: '告警分组',
                authCodes: ['LOGICAL_ALARM_RULES'],
                icon: 'Danger2',
                children: [],
              }
            ],
          },
          {
            path: '/ibms/device-alarm-rule-config',
            title: '设备告警规则',
            authCodes: ['DEVICE_ALARM_RULE'],
            icon: 'Danger2',
            children: [],
          }
        ],
      },
      {
        path: '/ibms/work-order/shield',
        title: '工单屏蔽',
        authCodes: ['WORK_ORDER_BLOCKING'],
        icon: 'Warning2',
        children: [
          {
            path: '/ibms/work-order/shield',
            title: '工单配置',
            authCodes: ['WORK_ORDER_BLOCKING'],
            icon: 'Danger2',
            children: [],
          },
          {
            path: '/ibms/work-order/record',
            title: '操作记录',
            authCodes: ['WORK_ORDER_BLOCKING'],
            icon: 'Danger2',
            children: [],
          }
        ],
      },
      {
        path: '/ibms/message-center',
        title: '消息中心',
        authCodes: ['MESSAGE_CENTER'],
        icon: 'List4',
        children: [
          {
            path: '/ibms/message-center/index',
            title: '设备离线历史',
            authCodes: ['DEVICE_OFFLINE_HISTORY'],
            icon: 'Danger2',
            children: [],
          },
          {
            path: '/dmp/message-center/sensor-monitor',
            title: '传感器监测',
            authCodes: ['SENSOR_MONITOR'],
            icon: 'Danger2',
            children: [
              {
                path: '/dmp/message-center/rtu-status',
                title: 'RTU当前状态',
                authCodes: ['SENSOR_MONITOR'],
                icon: 'Danger2',
                children: [],
              },
              {
                path: '/dmp/message-center/sub-rtu-status',
                title: 'RTU设备当前状态',
                authCodes: ['SENSOR_MONITOR'],
                icon: 'Danger2',
                children: [],
              },
              {
                path: '/dmp/message-center/rtu-offline-history',
                title: 'RTU离线历史',
                authCodes: ['SENSOR_MONITOR'],
                icon: 'Danger2',
                children: [],
              },
              {
                path: '/dmp/message-center/rtu-sub-offline-history',
                title: 'RTU子设备离线历史',
                authCodes: ['SENSOR_MONITOR'],
                icon: 'Danger2',
                children: [],
              }
            ],
          }
        ],
      },
      {
        path: '/ibms/fire-abnormal-target',
        title: '异常分析',
        authCodes: ['FIRE_ABNORMAL_TARGET'],
        icon: 'SuitcaseSearch',
        children: [],
      }
    ],
  },
  {
    path: '/quality',
    title: '品质',
    authCodes: ['SAFETY'],
    icon: 'safety',
    children: [
      {
        path: '/quality/map/index',
        title: '安全风险地图',
        authCodes: ['SECURITY_RISK_MAP'],
        icon: 'SuitcaseSearch',
        children: [],
      },
      {
        path: '/quality/fireProrection',
        title: '消防管理',
        authCodes: ['FIRE_PROTECTION'],
        icon: 'Loop',
        children: [
          {
            path: '/quality/fire/compartment',
            title: '消防分区',
            authCodes: ['FIRE_COMPARTMENT'],
            icon: 'SuitcaseSearch',
            children: [],
            meta: {
              isThreeModel: true,
            },
          }
        ],
      },
      {
        path: '/quality/event/center',
        title: '巡检事件中心',
        authCodes: ['INSPECTION_EVENT_CENTER'],
        icon: 'SuitcaseSearch',
        children: [],
        meta: {
          isThreeModel: true,
        },
      },
      {
        path: '/quality/duty',
        title: '巡检执行',
        authCodes: ['INSPECTION_TASK'],
        icon: 'Loop',
        children: [
          {
            path: '/quality/duty/random',
            title: '随机巡检',
            authCodes: ['INSPECTION_TASK_RANDOM'],
            icon: 'SuitcaseSearch',
            children: [],
            meta: {
              isThreeModel: true,
            },
          },
          {
            path: '/quality/duty/random',
            title: '计划巡检',
            authCodes: ['INSPECTION_TASK_PLAN'],
            icon: 'SuitcaseSearch',
            children: [],
          },
          {
            path: '/insight/clound/execute',
            title: '云督勤',
            authCodes: ['INSPECTION_TASK_CLOUD'],
            icon: 'SuitcaseSearch',
            children: [],
          },
          {
            path: '/quality/duty/picture',
            title: '云巡检考评',
            authCodes: ['INSPECTION_TASK_PICTURE'],
            icon: 'SuitcaseSearch',
            children: [],
          }
        ],
      },
      {
        path: '/insight/ai/inspection',
        title: '巡检任务管理',
        authCodes: ['INSPECTION_TASK_CONFIG'],
        icon: 'Loop',
        children: [
          {
            path: '/insight/ai/inspection',
            title: 'AI巡检任务',
            authCodes: ['AI_INSPECTION_TASK'],
            icon: 'SuitcaseSearch',
            children: [],
          },
          {
            path: '/insight/clound/duty-config',
            title: '云督勤任务',
            authCodes: ['CLOUD_DUTY'],
            icon: 'SuitcaseSearch',
            children: [],
          }
        ],
      },
      {
        path: '/insight/ai-screen',
        title: '巡检场景管理',
        authCodes: ['SAFETY_SCREEN'],
        icon: 'Loop',
        children: [
          {
            path: '/insight/ai-screen/index',
            title: 'AI场景模板',
            authCodes: ['SAFETY_SCREEN_TEMPLATE'],
            icon: 'SuitcaseSearch',
            children: [],
          },
          {
            path: '/insight/ai-screen/house',
            title: 'AI算法仓库',
            authCodes: ['SAFETY_SCREEN_HOUSE'],
            icon: 'SuitcaseSearch',
            children: [
              {
                path: '/insight/ai-screen/screenHouse',
                title: 'AI算法仓库',
                authCodes: ['SAFETY_SCREEN_HOUSE'],
                icon: 'SuitcaseSearch',
                children: [],
              },
              {
                path: '/insight/ai-screen/screenPage',
                title: '边缘端算法模型',
                authCodes: ['SAFETY_SCREEN_HOUSE'],
                icon: 'SuitcaseSearch',
                children: [],
              }
            ],
          },
          {
            path: '/insight/clound/type-config',
            title: '云督勤场景',
            authCodes: ['CLOUD_TEMPLATE'],
            icon: 'SuitcaseSearch',
            children: [],
          },
          {
            path: '/insight/clound/point-config',
            title: '云督勤配置',
            authCodes: ['CLOUD_CONFIG'],
            icon: 'SuitcaseSearch',
            children: [],
          }
        ],
      },
      {
        path: '/insight/carous',
        title: '视频轮播',
        authCodes: ['VIDEO_CAROUS'],
        icon: 'Loop',
        children: [
          {
            path: '/insight/carous/index',
            title: '轮播大屏',
            authCodes: ['VIDEO_CAROUS_SCREEN'],
            icon: 'SuitcaseSearch',
            children: [],
            meta: {
              isOpenPage: true,
            },
          },
          {
            path: '/insight/carous/config',
            title: '轮播配置',
            authCodes: ['VIDEO_CAROUS_CONFIG'],
            icon: 'SuitcaseSearch',
            children: [],
          }
        ],
      },
      {
        path: '/report',
        title: '报表分析',
        authCodes: ['SAFE_STATEMENT_ANALYSIS'],
        icon: 'SuitcaseSearch',
        children: [
          {
            path: '/quality/report/ai-count',
            title: 'AI统计',
            authCodes: ['REPORT_AI_COUNT'],
            icon: 'SuitcaseSearch',
            children: [],
            meta: {
              isThreeModel: true,
            },
          },
          {
            path: '/insight/report/ai-rule',
            title: 'AI巡检分析',
            authCodes: ['REPORT_AI_RULE'],
            icon: 'SuitcaseSearch',
            children: [
              {
                path: '/insight/report/ai-rule/chart',
                title: 'AI巡检分析',
                authCodes: ['REPORT_AI_RULE'],
                icon: 'SuitcaseSearch',
                children: [],
              },
              {
                path: '/insight/report/ai-rule/detail',
                title: 'AI巡检分析详情',
                authCodes: ['REPORT_AI_RULE'],
                icon: 'SuitcaseSearch',
                children: [],
              }
            ],
          },
          {
            path: '/insight/report/random-rule',
            title: '随机巡检分析',
            authCodes: ['REPORT_RANDPM'],
            icon: 'SuitcaseSearch',
            children: [
              {
                path: '/insight/report/random-rule/chart',
                title: '总体概览',
                authCodes: ['REPORT_AI_RULE'],
                icon: 'SuitcaseSearch',
                children: [],
              },
              {
                path: '/insight/report/random-rule/detail',
                title: '统计详情',
                authCodes: ['REPORT_AI_RULE'],
                icon: 'SuitcaseSearch',
                children: [],
              }
            ],
          },
          {
            path: '/insight/report/workorder-rule',
            title: '工单看板',
            authCodes: ['REPORT_WORKORDER_REPORT'],
            icon: 'SuitcaseSearch',
            children: [],
          },
          {
            path: '/insight/report/video-device',
            title: '视频设备看板',
            authCodes: ['REPORT_VIDEO_DEVICE'],
            icon: 'SuitcaseSearch',
            children: [
              {
                path: '/insight/report/video-device/overview',
                title: '总体概览',
                authCodes: ['REPORT_VIDEO_DEVICE'],
                icon: 'SuitcaseSearch',
                children: [],
              },
              {
                path: '/insight/report/video-device/table',
                title: '统计详情',
                authCodes: ['REPORT_VIDEO_DEVICE'],
                icon: 'SuitcaseSearch',
                children: [],
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/ems',
    title: '能源',
    authCodes: ['EMS'],
    icon: 'energy',
    children: [
      {
        path: '/energy-conservation/index',
        title: '节能管理',
        authCodes: ['ENERGY_CONSERVATION'],
        icon: 'ChartsBoard',
        meta: {
          hidden: false,
          isThreeModel: true,
        },
      },
      {
        path: '/ems/home/index',
        title: '数据看板',
        authCodes: ['COCKPIT'],
        icon: 'ChartsBoard',
        meta: {
          hidden: true,
          isThreeModel: false,
        },
      },
      {
        path: '/ems/energy-analysis',
        title: '能源分析',
        authCodes: ['ENERGY_ANALYSE'],
        icon: 'DataAnalysis',
        children: [
          {
            path: '/ems/energy-analysis/project',
            title: '单项目统计分析',
            authCodes: ['ENERGY_ANALYSE_S'],
          },
          {
            path: '/ems/energy-analysis/multiple-projects',
            title: '多项目统计分析',
            authCodes: ['ENERGY_ANALYSE_M'],
          },
          {
            path: '/ems/energy-analysis/branch-unbalanced',
            title: '数据质量看板',
            authCodes: ['ENERGY_ANALYSE_DASH'],
          },
          {
            path: '/ems/energy-analysis/meta-branch-topology',
            title: '表具支路拓扑',
            authCodes: ['META_BRANCH_TOPOLOGY'],
          },
          {
            path: '/ems/energy-analysis/energy-branch-topology',
            title: '能耗分项拓扑',
            authCodes: ['ENERGY_TOPOLOGY'],
          },
          {
            path: '/ems/energy-analysis/energy-report-manage',
            title: '能耗报告管理',
            authCodes: ['ENERGY_REPORT_MANAGE'],
          }
        ],
      },
      {
        path: '/ems/energy',
        title: '能源报表',
        authCodes: ['ACHIEVE_DATA'],
        icon: 'ChartsBoard',
        children: [
          {
            path: '/ems/energy/energy-take-report/index',
            title: '能耗发生报表',
            authCodes: ['ENERGY_REPORT'],
          },
          {
            path: '/ems/energy/energy-detail/index',
            title: '能耗明细报表',
            authCodes: ['ENERGY_DETAIL'],
          },
          {
            path: '/ems/energy/meter-detail-hourly/index',
            title: '逐时/逐日查询',
            authCodes: ['ENERGY_HOURLY'],
          },
          {
            path: '/ems/energy/meter-detail/index',
            title: '统计表底数查询',
            authCodes: ['METER_DETAIL'],
          },
          {
            path: '/ems/energy/meter-detail-original/index',
            title: '原始表底数查询',
            authCodes: ['METER_DETAIL_ORIGINAL'],
          },
          {
            path: '/ems/energy/ocr-report/index',
            title: 'OCR报表',
            authCodes: ['ENERGY_OCR'],
          }
        ],
      },
      {
        path: '/ems/energy-target',
        title: '目标管理',
        authCodes: ['ENERGY_TARGET'],
        icon: 'ForkedTree',
        children: [
          {
            path: '/ems/energy-conservation-board/index',
            title: '节能看板',
            authCodes: ['ENERGY_CONSERVATION_BOARD'],
          },
          {
            path: '/ems/energy-target/energy/index',
            title: '能耗目标管理',
            authCodes: ['SUBMENU_ENERGY_TARGET'],
          },
          {
            path: '/ems/energy-target/energy/cost-budget/index',
            title: '费用预算管理',
            authCodes: ['ENERGY_FEE_BUDGET'],
          }
        ],
      },
      {
        path: '/ems/strategy-and-model',
        title: '策略及模型',
        authCodes: ['STRATEGY_AND_MODEL'],
        icon: 'Materials1',
        children: [
          {
            path: '/ems/time-model/index',
            title: '时间策略',
            authCodes: ['TIME_MODEL'],
          },
          {
            path: '/ems/energy-model/index',
            title: '能耗模型',
            authCodes: ['MODEL'],
          },
          {
            path: '/ems/alarm/alarm-rule-config/index',
            title: '报警规则',
            authCodes: ['ALARM_RULE_CONFIG'],
          },
          {
            path: '/ems/alarm/energy-alarm-rule-config/index',
            title: '项目报警配置',
            authCodes: ['ENERGY_ALARM_RULE_CONFIG'],
          }
        ],
      },
      {
        path: '/ems/cost',
        title: '租户费用',
        authCodes: ['COST'],
        icon: 'Price1',
        children: [
          {
            path: '/ems/cost/config/tenant-manage',
            title: '租户管理',
            authCodes: ['TENANT_MANAGE'],
          },
          {
            path: '/ems/cost/config/tenant-cost',
            title: '费用明细',
            authCodes: ['TENANT_COST'],
          },
          {
            path: '/ems/cost/config/cost-scheme-config',
            title: '费用方案配置',
            authCodes: ['COST_SCHEME_CONFIG'],
          }
        ],
      },
      {
        path: '/ems/energy-input',
        title: '填报管理',
        authCodes: ['MANUAL_FILLING'],
        icon: 'List6',
        children: [
          {
            path: '/ems/energy-input/manual-stopwatch/index',
            title: '人工抄表',
            authCodes: ['MANUAL_METERM'],
          },
          {
            path: '/ems/energy-input/merchant-data-patching/index',
            title: '表底数修正',
            authCodes: ['MERCHANT_DATA_PATCHING'],
          },
          {
            path: '/ems/energy-input/meter-reading-config/index',
            title: '抄表计划配置',
            authCodes: ['METER_READING_CONFIG'],
          },
          {
            path: '/ems/energy-input/monthly-energy-report/index',
            title: '月度能耗填报',
            authCodes: ['MONTHLY_ENERGY'],
          },
          {
            path: '/ems/energy-input/ocr-meter/index',
            title: 'OCR抄表数据',
            authCodes: ['OCR_METER_DATA'],
          }
        ],
      }
    ],
  },
  {
    path: '/oss',
    title: '运维',
    authCodes: ['OPERATION'],
    icon: 'oss',
    children: [
      {
        path: '/oss/index',
        title: '运维看板',
        authCodes: ['OSS_BOARD'],
        icon: 'ModeList',
      },
      {
        path: '/oss/realtime',
        title: '全局告警',
        authCodes: ['ALARM'],
        icon: 'Danger2',
        children: [
          {
            path: '/oss/realtime',
            title: '实时告警',
            authCodes: ['REAL_TIME_ALARM'],
            icon: 'Danger2',
            children: [],
            meta: {
              isThreeModel: true,
            },
          },
          {
            path: '/oss/history',
            title: '历史告警',
            authCodes: ['HISTORY_ALARM'],
            icon: 'Danger2',
            children: [],
          },
          {
            path: '/oss/quarantime',
            title: '隔离告警',
            authCodes: ['QUARANTINE_ALARM'],
            icon: 'Danger2',
            children: [],
          }
        ],
      },
      {
        path: '/ibms/equip-health/index',
        title: '设备健康度',
        authCodes: ['EQUIPMENT_HEALTH'],
        icon: 'ModeList',
      },
      {
        path: '/ibms/fire-maintenance',
        title: '智能维保',
        authCodes: ['INTELLIGENT_MAINTENANCE'],
        icon: 'Danger2',
        children: [
          {
            path: '/ibms/fire-maintenance/inspection',
            title: '消防维保检测',
            authCodes: ['FIRE_MAINTENANCE_MONITORING'],
            icon: 'Danger2',
            children: [
              {
                path: '/ibms/fire-maintenance/fire-group',
                title: '消防分区',
                authCodes: ['FIRE_MAINTENANCE_MONITORING_FIRE_GROUP'],
                icon: 'SuitcaseSearch',
                children: [],
              },
              {
                path: '/ibms/fire-maintenance/maintenance-plan',
                title: '维保计划',
                authCodes: ['FIRE_MAINTENANCE_MONITORING_MAINTENANCE_PLAN'],
                icon: 'SuitcaseSearch',
                children: [],
              },
              {
                path: '/ibms/fire-maintenance/maintenance-task',
                title: '维保任务',
                authCodes: ['FIRE_MAINTENANCE_MONITORING_MAINTENANCE_TASK'],
                icon: 'SuitcaseSearch',
                children: [],
              }
            ],
          },
          {
            path: '/oss/maintenance/dianti',
            title: '电梯维保检测',
            authCodes: ['ELEVATOR_MAINTENANCE_MONITORING'],
            icon: 'Danger2',
            children: [],
          }
        ],
      },
      {
        path: '/ibms/acceptance-management',
        title: '验收管理',
        authCodes: ['ACCEPTANCE_MANAGEMENT'],
        icon: 'Handshake',
        children: [
          {
            path: '/ibms/acceptance-management/standard',
            title: '标准管理',
            authCodes: ['STANDARD_MANAGEMENT'],
            icon: 'Danger2',
            children: [],
          },
          {
            path: '/ibms/acceptance-management/automatic',
            title: '自动化验收',
            authCodes: ['AUTOMATED_ACCEPTANCE'],
            icon: 'Danger2',
            children: [],
          }
        ],
      },
      {
        path: '/work-order-system',
        title: '工单系统',
        authCodes: ['OPERATION'],
        icon: 'Danger2',
        blank: true,
        targetUrl: '',
      }
    ],
  },
  {
    path: '/tcy',
    title: '通行',
    authCodes: ['TCY'],
    icon: 'tcy',
    children: [],
  },
  {
    path: '/astm',
    title: '资产',
    authCodes: ['ASTM'],
    icon: 'ibms',
    children: [],
  },
  {
    path: '/quality',
    title: '安全',
    authCodes: ['QUALITY'],
    icon: 'safety',
    children: [],
  },
  {
    path: '/space',
    title: '空间',
    authCodes: ['SPACE'],
    icon: 'space',
    children: [
      {
        path: '/space/space-tree/index',
        title: '空间树管理',
        authCodes: ['SPACE_TREE'],
        icon: 'OrgStru',
        children: [],
      },
      {
        path: '/space/device-ledger/index',
        title: '设备台账',
        authCodes: ['DEVICE_LEDGER'],
        icon: 'OrgStru',
        children: [],
      },
      {
        path: '/space/draw',
        title: '空间绘制',
        authCodes: ['SPACE_DRAW'],
        icon: 'ModeList',
        meta: {
          hidden: false,
          isThreeModel: true,
        },
      },
      {
        path: '/space/location/index',
        title: '设备落位',
        authCodes: ['DEVICE_LOCATION'],
        icon: 'MapLocation2',
        children: [],
        meta: {
          hidden: true,
          isThreeModel: true,
        },
      },
      {
        path: '/space/area',
        title: '分区管理',
        authCodes: ['SPACE_AREA'],
        icon: 'ModeList',
        meta: {
          hidden: true,
          isThreeModel: true,
        },
      },
      {
        path: '/space/model-config',
        title: '模型组件管理',
        authCodes: ['MODEL_CONFIG'],
        icon: 'ModeList',
        children: [
          {
            path: '/space/model-config/equipment-icon-config',
            title: '设备图标配置',
            authCodes: ['QEUIPMENT_ICON_CONFIG'],
          },
          {
            path: '/space/model-config/order-icon-config',
            title: '工单图标配置',
            authCodes: ['ORDER_ICON_CONFIG'],
          }
        ],
      },
      {
        path: '/space/online',
        title: '空间在线',
        authCodes: ['TARGET_SPACE_ONLINE'],
        icon: 'Danger2',
        blank: true,
        targetUrl: '',
      }
    ],
  },
  {
    path: '/system',
    title: '配置',
    authCodes: ['SYSTEM'],
    icon: 'system',
    children: [
      {
        path: '/system/overall-device-manage',
        title: '设备管理',
        authCodes: ['OVERALL_DEVICE_MANAGE'],
        icon: 'Process1',
        children: [
          {
            path: '/ibms/ibms-device',
            title: '运行设备',
            authCodes: ['OVERALL_DEVICE_MANAGE_IBMS'],
            children: [
              {
                path: '/ibms/gateway-device',
                title: '网关',
                authCodes: ['OVERALL_DEVICE_MANAGE_IBMS'],
                icon: 'Danger2',
                children: [],
              },
              {
                path: '/ibms/device',
                title: '设备',
                authCodes: ['OVERALL_DEVICE_MANAGE_IBMS'],
                icon: 'Danger2',
                children: [],
              }
            ],
          },
          {
            path: '/ems/device',
            title: '能源设备',
            authCodes: ['OVERALL_DEVICE_MANAGE_EMS'],
            children: [
              {
                path: '/ems/device/service/index',
                title: '服务器管理',
                authCodes: ['SERVICE'],
                icon: 'Danger2',
                children: [],
              },
              {
                path: '/ems/device/gateway/index',
                title: '网关管理',
                authCodes: ['OVERALL_DEVICE_MANAGE_EMS_GATEWAY'],
                icon: 'Danger2',
                children: [],
              },
              {
                path: '/ems/device/energy-meter/index',
                title: '电表管理',
                authCodes: ['OVERALL_DEVICE_MANAGE_EMS_ENERGY_METER'],
                icon: 'Danger2',
                children: [],
              },
              {
                path: '/ems/device/water-meter/index',
                title: '水表管理',
                authCodes: ['OVERALL_DEVICE_MANAGE_EMS_WATER_METER'],
                icon: 'Danger2',
                children: [],
              },
              {
                path: '/ems/device/gas-meter/index',
                title: '气表管理',
                authCodes: ['OVERALL_DEVICE_MANAGE_EMS_GAS_METER'],
                icon: 'Danger2',
                children: [],
              },
              {
                path: '/ems/device/hot-meter/index',
                title: '热量表管理',
                authCodes: ['HOT_METER'],
                icon: 'Danger2',
                children: [],
              },
              {
                path: '/ems/device/cold-meter/index',
                title: '冷量表管理',
                authCodes: ['COLD_METER'],
                icon: 'Danger2',
                children: [],
              }
            ],
          },
          {
            path: '/insight/insight-device',
            title: '视频设备',
            authCodes: ['OVERALL_DEVICE_MANAGE_VIDEO'],
            children: [
              {
                path: '/insight/gateway-device',
                title: '网关',
                authCodes: ['OVERALL_DEVICE_MANAGE_VIDEO'],
                icon: 'Danger2',
                children: [],
              },
              {
                path: '/insight/device',
                title: '摄像头',
                authCodes: ['OVERALL_DEVICE_MANAGE_VIDEO'],
                icon: 'Danger2',
                children: [],
              },
              {
                path: '/insight/nvr',
                title: 'NVR',
                authCodes: ['OVERALL_DEVICE_MANAGE_VIDEO'],
                icon: 'Danger2',
                children: [],
              },
              {
                path: '/insight/edge-ai',
                title: '边缘AI服务器',
                authCodes: ['OVERALL_DEVICE_MANAGE_VIDEO'],
                icon: 'Danger2',
                children: [],
              },
              {
                path: '/insight/ota',
                title: '固件管理',
                authCodes: ['OVERALL_DEVICE_MANAGE_VIDEO'],
                icon: 'Danger2',
                children: [],
              }
            ],
          },
          {
            path: '/system/overall-device-manage/dictionary',
            title: '设备字典',
            authCodes: ['OVERALL_DEVICE_MANAGE_DICTIONARY'],
          },
          {
            path: '/system/overall-device-manage/device-import-history',
            title: '设备导入历史',
            authCodes: ['OVERALL_DEVICE_MANAGE_DICTIONARY'],
          }
        ],
      },
      {
        path: '/system',
        title: '物联管理',
        authCodes: ['DMP_MANAGE'],
        icon: 'Process1',
        children: [
          {
            path: '/dmp/product/index',
            title: '设备类型',
            authCodes: ['DEVICE_TYPE_MANAGE'],
            icon: 'Process1',
          },
          {
            path: '/dmp/device/index',
            title: '设备',
            authCodes: ['DEVICE_MANAGE'],
            icon: 'Process1',
          },
          {
            path: '/dmp/physical-model/manage',
            title: '物模型管理',
            authCodes: ['PHYSICAL_MODEL_MANAGE'],
            icon: 'Process1',
            children: [
              {
                path: '/dmp/physical-model/category-config',
                title: '品类配置',
                authCodes: ['PHYSICAL_MODEL_MANAGE'],
                icon: 'Process1',
              },
              {
                path: '/dmp/physical-model/function-property-config',
                title: '功能属性配置',
                authCodes: ['PHYSICAL_MODEL_MANAGE'],
                icon: 'Process1',
              }
            ],
          },
          {
            path: '/dmp/log-serve',
            title: '设备日志',
            authCodes: ['LOG_MANAGE'],
            icon: 'Process1',
            children: [
              {
                path: '/dmp/operate-log',
                title: '操作日志',
                authCodes: ['LOG_MANAGE'],
                icon: 'Process1',
              },
              {
                path: '/dmp/device-log',
                title: '设备日志',
                authCodes: ['LOG_MANAGE'],
                icon: 'Process1',
              }
            ],
          },
          {
            path: '/dmp/rule/index',
            title: '规则引擎',
            authCodes: ['RULE_ENGINE'],
            icon: 'Process1',
            children: [
              {
                path: '/dmp/rule/config',
                title: '规则配置',
                authCodes: ['RULE_ENGINE'],
                icon: 'Process1',
              },
              {
                path: '/dmp/rule/resource',
                title: '资源配置',
                authCodes: ['RULE_ENGINE'],
                icon: 'Process1',
              }
            ],
          },
          {
            path: '/dmp/gateway-manage',
            title: '网关管理',
            authCodes: ['GATEWAY_MANAGE'],
            icon: 'Process1',
            children: [
              {
                path: '/dmp/rtu-manage/index',
                title: 'RTU管理',
                authCodes: ['GATEWAY_MANAGE'],
                icon: 'Process1',
              },
              {
                path: '/dmp/rtu-template/index',
                title: '模板管理',
                authCodes: ['GATEWAY_MANAGE'],
                icon: 'Process1',
              },
              {
                path: '/dmp/rtu-log/index',
                title: '下发日志',
                authCodes: ['GATEWAY_MANAGE'],
                icon: 'Process1',
              }
            ],
          }
        ],
      },
      {
        path: '/system/ibms/config',
        title: '运行配置',
        authCodes: ['IBMS_CONFIG'],
        icon: 'ModeList',
        children: [
          {
            path: '/system/device/bianyuan',
            title: '边缘管理',
            authCodes: ['EDGE_MANAGEMENT'],
            icon: 'Toolts',
            children: [],
          },
          {
            path: '/system/device/tool',
            title: '调试工具',
            authCodes: ['IBMS_DEBUG_TOOL'],
            icon: 'Toolts',
            children: [],
          },
          {
            path: '/ibms/relative-time/index',
            title: '相对时间配置',
            authCodes: ['IBMS_RELATIVE_TIME'],
            icon: 'Toolts',
            children: [],
          },
          {
            path: '/ibms/relative-time/inner',
            title: '边缘端时间表',
            authCodes: ['IBMS_INNER_RELATIVE_TIME'],
            icon: 'Toolts',
            children: [],
          },
          {
            path: '/ibms/issue-history',
            title: '模式下发日志',
            authCodes: ['ISSUE_HISTORY_RECORD'],
            icon: 'Toolts',
            children: [],
          },
          {
            path: '/system/device/log',
            title: '操作日志',
            authCodes: ['IBMS_OPERATION_LOG'],
            icon: 'Toolts',
            children: [],
          },
          {
            path: '/system/device/config',
            title: '设备监控配置',
            authCodes: ['DEVICE_DETECTION_CONFIG'],
            icon: 'ModeList',
            children: [],
          },
          {
            path: '/system/device/light',
            title: '智慧照明',
            authCodes: ['SMART_LIGHTING'],
            icon: 'ModeList',
            children: [],
          }
        ],
      },
      {
        path: '/insight/config',
        title: '安全配置',
        authCodes: ['SAFE_CONFIG'],
        icon: 'Process1',
        children: [
          {
            path: '/insight/config/work-order-type',
            title: '工单类型管理',
            authCodes: ['WORK_ORDER_TYPE_MANAGE'],
            icon: 'Toolts',
            children: [],
          }
        ],
      },
      {
        path: '/system/energy',
        title: '能耗配置',
        authCodes: ['CONSUMPTION_CONFIG'],
        icon: 'Process1',
        children: [],
      },
      {
        path: '/system/general',
        title: '通行配置',
        authCodes: ['TRANSIT_CONFIG'],
        icon: 'Process1',
        children: [],
      },
      {
        path: '/ems/operator',
        title: '能源运维工具',
        authCodes: ['OPERATOR_TOOLS'],
        icon: 'Setting',
        children: [
          {
            path: '/ems/operator/template/index',
            title: '运维',
            authCodes: ['TEMPLATE_MGT'],
            icon: 'Process1',
          },
          {
            path: '/ems/operator/energy-ck/index',
            title: '能耗采样进度表',
            authCodes: ['ENERGY_CY'],
            icon: 'Process1',
          },
          {
            path: '/ems/operator/energy-computed/index',
            title: '能耗计算进度表',
            authCodes: ['ENERGY_JS'],
            icon: 'Process1',
          },
          {
            path: '/ems/operator/energy-cck/index',
            title: '重采样进度表',
            authCodes: ['ENERGY_CCY'],
            icon: 'Process1',
          },
          {
            path: '/ems/operator/energy-recomputed/index',
            title: '重计算进度表',
            authCodes: ['ENERGY_CJS'],
            icon: 'Process1',
          },
          {
            path: '/ems/operator/his-data-migration/index',
            title: '历史数据迁移',
            authCodes: ['HIS_DATA_MIGRATION'],
            icon: 'Process1',
          },
          {
            path: '/ems/operator/device-migration-tool/index',
            title: '设备迁移工具',
            authCodes: ['DEVICE_MIGRATION_TOOL'],
            icon: 'Process1',
          },
          {
            path: '/ems/operator/data-patching/index',
            title: '人工修补数据',
            authCodes: ['DATA_PATCHING'],
            icon: 'Process1',
          },
          {
            path: '/ems/operator/anomaly-data-monitoring/index',
            title: '异常数据监控',
            authCodes: ['ANOMALY_DATA_MONITORING'],
            icon: 'Process1',
          },
          {
            path: '/ems/operator/dict-manage/index',
            title: '字典管理',
            authCodes: ['DICT_MANAGE'],
            icon: 'Process1',
          }
        ],
      },
      {
        path: '/system/project/index',
        title: '项目信息管理',
        authCodes: ['PROJECT_INFO'],
        icon: 'Process1',
        children: [],
      },
      {
        path: '/system/operate-log',
        title: '用户日志',
        authCodes: ['OPERATION_LOG_MANAGE'],
        icon: 'Process1',
        children: [],
      }
    ],
  },
  {
    path: '/user',
    title: '账号',
    authCodes: ['ACCOUNT'],
    icon: 'home',
    children: [
      {
        path: '/roleManage/index',
        title: '角色管理',
        authCodes: [
          'ROLE_MANAGE'
        ],
        icon: 'Process1',
        children: [],
      },
      {
        path: '/organizationalManage/index',
        title: '组架管理',
        authCodes: [
          'ORGANIZATIONAL_MANAGE'
        ],
        icon: 'Process1',
        children: [],
      }
    ],
  }
];

export const menuList = VITE_APP_CHANNEL === 'C2' ? c2MenuList : c4MenuList;
